import {
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAIL,
    GET_CITIES_BY_COUNTRY_SUCCESS,
  GET_CITIES_BY_COUNTRY_FAIL
} from "./actionTypes";

const INIT_STATE = {
  cities: [],
  countries: [],
  error: {},
  loading:false
};

const address = (state = INIT_STATE, action) => {
  // console.log(action)
  switch (action.type) {
    case GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: action.payload.data,
      }

    case GET_COUNTRIES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CITIES_BY_COUNTRY_SUCCESS:
      return {
        ...state,
        cities: action.payload.data,
      }

    case GET_CITIES_BY_COUNTRY_FAIL:
      return {
        ...state,
        error: action.payload,
      }
   default:
      return state
  
  }
};

export default address;
